import produce from 'immer';
import {
  GET_CMS_PAGES_START,
  GET_CMS_PAGES_SUCCESS,
  GET_CMS_PAGES_FAILED,
  UPDATE_CMS_PAGE_START,
  UPDATE_CMS_PAGE_SUCCESS,
  UPDATE_CMS_PAGE_FAILED,
  UPDATE_REWARD_PAGE
} from '../actions/cms_pages';

import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';


const initialState = {
  cmsPages: [],
  loadingCmsPages: false,
  loadingUpdateCmsPages: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_CMS_PAGES_START: {
      state.loadingCmsPages = true;
      break;
    }
    case GET_CMS_PAGES_SUCCESS: {
      const { data } = action;

      state.cmsPages = data;
      state.loadingCmsPages = false;

      break;
    }
    case GET_CMS_PAGES_FAILED: {
      state.loadingCmsPages = false;
      break;
    }
    case UPDATE_CMS_PAGE_START: {
      state.loadingUpdateCmsPages = true;
      break;
    }
    case UPDATE_CMS_PAGE_SUCCESS: {
      const {data} = action;

      state.cmsPages = state.cmsPages.map((page) => page.id === data.id ? data : page);
      state.loadingUpdateCmsPages = false;

      break;
    }
    case UPDATE_CMS_PAGE_FAILED: {
      state.loadingUpdateCmsPages = false;
      break;
    }
    case UPDATE_REWARD_PAGE: {
      const {page} = action;

      state.cmsPages = state.cmsPages.map((p) => p.id === page.id ? page : p);
      break;
    }
    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.cmsPages = [];

      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
